import { Body1, Stack, Subheader2 } from '@collaborate-health/uikit'

export interface InfoRowProps {
  label: string
  children: React.ReactNode | string
}

const InfoRow: React.FC<InfoRowProps> = ({ label, children }) => {
  return (
    <Stack direction='row' justifyContent='space-between' gap={2}>
      <Subheader2 mt='2px'>{label}</Subheader2>
      {typeof children === 'string' ? <Body1 noWrap>{children}</Body1> : children}
    </Stack>
  )
}

export default InfoRow

